import { useState } from 'react';
import { Link } from 'react-router-dom';
import PageLayout from '@/components/feature/PageLayout';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ContactForm from './components/ContactForm';

const scopeItems = [
  { icon: 'ri-film-line', title: '电影资料', desc: '涵盖国产与海外电影的完整资料介绍、剧情梗概与主创信息。' },
  { icon: 'ri-tv-2-line', title: '电视剧集', desc: '整理热播与经典剧集的剧集信息、题材标签与观众口碑。' },
  { icon: 'ri-newspaper-line', title: '影视资讯', desc: '更新行业动态、新片速递、人物专访与深度影评等多元内容。' },
  { icon: 'ri-bookmark-3-line', title: '作品推荐', desc: '按照类型、地区、年份多维推荐，帮助你更快找到想看的作品。' },
];

const steps = [
  { num: '01', title: '浏览与发现', desc: '在首页通过焦点推荐、分类快捷入口快速发现热门影视作品。' },
  { num: '02', title: '筛选与搜索', desc: '进入分类页按类型、地区、年份、题材多维筛选，或使用搜索精准定位。' },
  { num: '03', title: '查看详情', desc: '在作品详情页了解剧情简介、主创阵容与相关资讯，辅助你做出选择。' },
];

export default function About() {
  const [contactOpen, setContactOpen] = useState(false);

  return (
    <PageLayout>
      <div className="mx-auto w-full max-w-6xl px-4 py-8 md:px-8 md:py-10">
        <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '关于我们' }]} />

        <div className="mt-6 rounded-lg bg-foreground-950 px-6 py-10 md:px-12 md:py-14">
          <span className="inline-block rounded-full bg-primary-500/15 px-3 py-1 text-xs font-medium text-accent-400">
            关于红杏影视
          </span>
          <h1 className="mt-4 max-w-3xl font-heading text-2xl font-bold leading-snug text-background-50 md:text-4xl">
            让每一次选片，都更简单、更有依据
          </h1>
          <p className="mt-4 max-w-3xl text-sm leading-relaxed text-foreground-300 md:text-base">
            红杏影视是一个专注于影视资讯与作品资料展示的现代门户平台，面向广大影视爱好者，提供电影、电视剧的丰富资源介绍与最新影视动态。我们不提供在线播放与下载服务，而是专注于把内容信息整理得清晰、准确、易读。
          </p>
        </div>

        <section className="mt-12">
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">网站定位与内容范围</h2>
          <p className="mt-2 max-w-3xl text-sm leading-relaxed text-foreground-600">
            我们围绕"内容浏览、分类筛选、搜索与详情查看"构建体验，强调资讯更新与作品资料展示，帮助用户了解影视动态、查询作品详细信息。
          </p>
          <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {scopeItems.map((item) => (
              <div
                key={item.title}
                className="rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-200"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-50 text-primary-600">
                  <i className={`${item.icon} text-xl`} />
                </span>
                <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="mt-12">
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">使用说明</h2>
          <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-3">
            {steps.map((step) => (
              <div key={step.num} className="rounded-lg bg-background-100 p-6">
                <span className="font-heading text-2xl font-bold text-accent-500">{step.num}</span>
                <h3 className="mt-3 font-heading text-base font-semibold text-foreground-950">{step.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="mt-12 grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="rounded-lg border border-background-200 bg-background-50 p-6">
            <h3 className="font-heading text-lg font-bold text-foreground-950">运营团队</h3>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              红杏影视由一支热爱影视的内容编辑与产品团队共同运营，长期关注华语与海外影视作品的动态，坚持内容的真实与丰富，努力让每一份资料都经得起细看。
            </p>
          </div>
          <div className="rounded-lg border border-background-200 bg-background-50 p-6">
            <h3 className="font-heading text-lg font-bold text-foreground-950">联系方式</h3>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              内容纠错、作品推荐或合作咨询，欢迎随时与我们取得联系。
            </p>
            <button
              type="button"
              onClick={() => setContactOpen(true)}
              className="mt-4 flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-200 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              <i className="ri-mail-line" />
              查看联系邮箱
            </button>
          </div>
          <div className="flex flex-col justify-center rounded-lg bg-accent-50 p-6">
            <h3 className="font-heading text-lg font-bold text-accent-900">温馨提示</h3>
            <p className="mt-3 text-sm leading-relaxed text-accent-800/90">
              本站所有影视内容仅作资讯展示与交流用途，不提供任何在线播放、下载等实际服务，作品版权归原权利人所有。
            </p>
            <Link
              to="/category"
              className="mt-4 flex w-fit cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-medium text-accent-800 transition-colors hover:text-accent-900"
            >
              去浏览影视作品
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </section>

        <section className="mt-12">
          <div className="mb-6">
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">在线反馈</h2>
            <p className="mt-2 text-sm text-foreground-600">
              填写下方表单，把你的想法告诉我们，我们会认真阅读每一条反馈。
            </p>
          </div>
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-[1fr_320px]">
            <ContactForm />
            <div className="flex flex-col gap-4">
              <div className="rounded-lg bg-background-100 p-6">
                <h3 className="font-heading text-base font-semibold text-foreground-950">我们会关注</h3>
                <ul className="mt-4 flex flex-col gap-3 text-sm text-foreground-600">
                  {['影视资料是否准确完整', '资讯内容是否及时更新', '筛选与搜索是否好用', '你希望看到的新功能'].map(
                    (item) => (
                      <li key={item} className="flex items-start gap-2">
                        <i className="ri-checkbox-circle-line mt-0.5 text-primary-500" />
                        {item}
                      </li>
                    ),
                  )}
                </ul>
              </div>
              <div className="rounded-lg border border-background-200 bg-background-50 p-6">
                <h3 className="font-heading text-base font-semibold text-foreground-950">响应时间</h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                  我们通常会在 1-3 个工作日内查看并回复重要反馈，感谢你的耐心与支持。
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>

      {contactOpen && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center px-4">
          <div
            className="absolute inset-0 bg-foreground-950/50"
            onClick={() => setContactOpen(false)}
            aria-hidden="true"
          />
          <div className="relative w-full max-w-sm rounded-lg bg-background-50 p-6 text-center">
            <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-primary-50 text-primary-600">
              <i className="ri-mail-send-line text-2xl" />
            </span>
            <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">联系邮箱</h3>
            <p className="mt-2 text-sm text-foreground-600">欢迎通过邮件与我们取得联系</p>
            <p className="mt-3 select-all rounded-md bg-background-100 px-4 py-3 font-medium text-primary-700">
              contact@hongxing-film.com
            </p>
            <div className="mt-5 flex gap-3">
              <button
                type="button"
                onClick={() => setContactOpen(false)}
                className="h-11 flex-1 cursor-pointer whitespace-nowrap rounded-md border border-background-200 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300"
              >
                关闭
              </button>
              <a
                href="mailto:contact@hongxing-film.com"
                className="flex h-11 flex-1 cursor-pointer items-center justify-center whitespace-nowrap rounded-md bg-primary-500 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                发送邮件
              </a>
            </div>
          </div>
        </div>
      )}
    </PageLayout>
  );
}